import React, { Component } from "react";
import "../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bulma/css/bulma.css";
import NavBar from "./navbar";
import { Typography } from "antd";
import FooterPage from "./footer";

const { Title } = Typography;

class TermsPage extends Component {
  render() {
    return (
      <div>
        <NavBar />

        <div
          style={{ backgroundColor: "white" }}
          className="columns is-centered"
        >
          <div className="column">
            <Title style={{ fontSize: 40, fontWeight: 900 }}>
              Terms of Service
            </Title>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "white",
            textAlign: "left",
            paddingLeft: "200px",
            paddingRight: "200px",
          }}
          className="columns is-centered"
        >
          <div className="column">
            <p>Last updated: May 3, 2020</p>
            <p>
              From everyone at Froshbite, thank you for using our product! We
              built this web app to help you successfully navigate the college
              search process. Because we don't know every one of our customers
              personally, we have to put in place some Terms of Service to help
              keep the ship afloat. When we say “Company”, “we”, “our”, or “us”
              in this document, we are referring to Froshbite, LLC. When we say
              “Services”, we mean any product created and maintained by
              Froshbite, LLC. We may update these Terms of Service in the
              future. Typically these changes have been to clarify some of these
              terms by linking to an expanded related policy.
            </p>
            <p>
              Whenever we make a significant change to our policies, we will
              also announce them on our company blog. When you use our Services,
              now or in the future, you are agreeing to the latest Terms of
              Service. That's true for any of our existing and future products
              and all features that we add to our Services over time. There may
              be times where we do not exercise or enforce any right or
              provision of the Terms of Service; in doing so, we are not waiving
              that right or provision. These terms do contain a limitation of
              our liability.
            </p>
            <p>
              If you violate of any of the terms, we may terminate your account.
              That's a broad statement and it means you need to place a lot of
              trust in us. We do our best to deserve that trust by being open
              about who we are, how we work, and keeping an open door to{" "}
              <a
                href="mailto:hello@froshbite.com?Subject=Hello%20There!"
                target="_top"
              >
                hello@froshbite.com
              </a>
              .
            </p>

            <Title
              style={{ fontSize: 20, fontWeight: 600, paddingTop: "20px" }}
            >
              Account Terms
            </Title>
            <ol>
              <li>
                You are responsible for maintaining the security of your account
                and password. The Company cannot and will not be liable for any
                loss or damage from your failure to comply with this security
                obligation.
              </li>
              <li>
                You are responsible for all content posted and activity that
                occurs under your account. That includes content posted by
                others who either: (a) have access to your login credentials; or
                (b) have their own logins under your account.
              </li>
              <li>
                You must be a human. Accounts registered by “bots” or other
                automated methods are not permitted.
              </li>
            </ol>
            <Title
              style={{ fontSize: 20, fontWeight: 600, paddingTop: "20px" }}
            >
              Payment, Refunds, and Plan Changes
            </Title>
            <ol>
              <li>
                If you are using a free version of one of our Services, it is
                really free: we do not ask you for your credit card and — just
                like for customers who pay for our Services — we do not sell
                your data.
              </li>
              <li>
                If you are upgrading from a free plan to a paid plan, we will
                charge your card immediately and your billing cycle starts on
                the day of upgrade. For other upgrades or downgrades in plan
                level, the new rate starts from the next billing cycle.
              </li>
              <li>
                All fees are exclusive of all taxes, levies, or duties imposed
                by taxing authorities. Where required, we will collect those
                taxes on behalf of the taxing authority and remit those taxes to
                taxing authorities. Otherwise, you are responsible for payment
                of all taxes, levies, or duties.
              </li>
            </ol>
            <Title
              style={{ fontSize: 20, fontWeight: 600, paddingTop: "20px" }}
            >
              Cancellation and Termination
            </Title>
            <ol>
              <li>
                You are solely responsible for properly canceling your account.
                Within each of our Services, we provide a simple
                no-questions-asked cancellation link. An email or phone request
                to cancel your account is not automatically considered
                cancellation. If you need help cancelling your account, you can
                always contact our Support team{" "}
                <a
                  href="mailto:hello@froshbite.com?Subject=Hello%20There!"
                  target="_top"
                >
                  hello@froshbite.com
                </a>
                .
              </li>
              <li>
                All of your content will be inaccessible from the Services
                immediately upon cancellation. Within 30 days, all content will
                be permanently deleted from active systems and logs. Within 60
                days, all content will be permanently deleted from our backups.
                We cannot recover this information once it has been permanently
                deleted.
              </li>
              <li>
                We have the right to suspend or terminate your account and
                refuse any and all current or future use of our Services for any
                reason at any time. Suspension means you and any other users on
                your account will not be able to access the account or any
                content in the account. Termination will furthermore result in
                the deletion of your account or your access to your account, and
                the forfeiture and relinquishment of all content in your
                account. We also reserve the right to refuse the use of the
                Services to anyone for any reason at any time.
              </li>
              <li>
                Verbal, physical, written or other abuse (including threats of
                abuse or retribution) of Company employee or officer will result
                in immediate account termination.
              </li>
            </ol>
            <Title
              style={{ fontSize: 20, fontWeight: 600, paddingTop: "20px" }}
            >
              Modifications to the Service and Prices
            </Title>
            <ol>
              <li>
                When it comes to security, privacy, and customer support, we
                will continue to maintain any legacy Services. Sometimes it
                becomes technically impossible to continue a feature or we
                redesign a part of our Services because we think it could be
                better or we decide to close new signups of a product. We
                reserve the right at any time to modify or discontinue,
                temporarily or permanently, any part of our Services with or
                without notice.
              </li>
              <li>
                Sometimes we change the pricing structure for our products. When
                we do that, we tend to exempt existing customers from those
                changes. However, we may choose to change the prices for
                existing customers. If we do so, we will give at least 30 days
                notice and will notify you via the email address on record. We
                may also post a notice about changes on our websites or the
                affected Services themselves.
              </li>
            </ol>
            <Title
              style={{ fontSize: 20, fontWeight: 600, paddingTop: "20px" }}
            >
              Uptime, Security, and Privacy
            </Title>
            <ol>
              <li>
                Your use of the Services is at your sole risk. We provide these
                Services on an “as is” and “as available” basis.
              </li>
              <li>
                We reserve the right to temporarily disable your account if your
                usage significantly exceeds the average usage of other customers
                of the Services. Of course, we'll reach out to the account owner
                before taking any action except in rare cases where the level of
                use may negatively impact the performance of the Service for
                other customers.
              </li>
              <li>
                When you use our Services, you entrust us with your data. We
                take that trust to heart. You agree that Froshbite may process
                your data as described in our Privacy Policy and for no other
                purpose. We as humans can access your data for the following
                reasons: To help you with support requests you make. We'll ask
                for express consent before accessing your account. To safeguard
                Froshbite. We'll look at logs and metadata as part of our work
                to ensure the security of your data and the Services as a whole.
                If necessary, we may also access accounts as part of an abuse
                report investigation. To the extent required by applicable law.
              </li>
            </ol>
            <Title
              style={{ fontSize: 20, fontWeight: 600, paddingTop: "20px" }}
            >
              Copyright and Content Ownership
            </Title>
            <ol>
              <li>
                All content posted on the Services must comply with U.S.
                copyright law.
              </li>
              <li>
                We claim no intellectual property rights over the material you
                provide to the Services. All materials uploaded remain yours.
              </li>
              <li>
                We do not pre-screen content, but reserve the right (but not the
                obligation) in our sole discretion to refuse or remove any
                content that is available via the Service.
              </li>
              <li>
                The names, look, and feel of the Services are copyright© to the
                Company. All rights reserved. You may not duplicate, copy, or
                reuse any portion of the HTML, CSS, JavaScript, or visual design
                elements without express written permission from the Company.
              </li>
              <li>
                You agree not to reproduce, duplicate, copy, sell, resell or
                exploit any portion of the Services, use of the Services, or
                access to the Services without the express written permission by
                the Company.
              </li>
              <li>
                You must not modify another website so as to falsely imply that
                it is associated with the Services or the Company.
              </li>
            </ol>
            <Title
              style={{ fontSize: 20, fontWeight: 600, paddingTop: "20px" }}
            >
              Features and Bugs
            </Title>
            <p>
              We design our Services with care, based on our own experience and
              the experiences of customers who share their time and feedback.
              However, there is no such thing as a service that pleases
              everybody. We make no guarantees that our Services will meet your
              specific requirements or expectations.
            </p>
            <p>
              We also test all of our features extensively before shipping them.
              As with any software, our Services inevitably have some bugs. We
              track the bugs reported to us and work through priority ones,
              especially any related to security or privacy. Not all reported
              bugs will get fixed and we don't guarantee completely error-free
              Services.
            </p>
            <Title
              style={{ fontSize: 20, fontWeight: 600, paddingTop: "20px" }}
            >
              Liability
            </Title>
            <p>
              We mention liability throughout these Terms but to put it all in
              one section:
            </p>
            <p>
              You expressly understand and agree that the Company shall not be
              liable, in law or in equity, to you or to any third party for any
              direct, indirect, incidental, lost profits, special,
              consequential, punitive or exemplary damages, including, but not
              limited to, damages for loss of profits, goodwill, use, data or
              other intangible losses (even if the Company has been advised of
              the possibility of such damages), resulting from: (i) the use or
              the inability to use the Services; (ii) the cost of procurement of
              substitute goods and services resulting from any goods, data,
              information or services purchased or obtained or messages received
              or transactions entered into through or from the Services; (iii)
              unauthorized access to or alteration of your transmissions or
              data; (iv) statements or conduct of any third party on the
              service; (v) or any other matter relating to this Terms of Service
              or the Services, whether as a breach of contract, tort (including
              negligence whether active or passive), or any other theory of
              liability.
            </p>
            <p>
              If you have a question about any of the Terms of Service, please
              contact our Support team{" "}
              <a
                href="mailto:hello@froshbite.com?Subject=Hello%20There!"
                target="_top"
              >
                hello@froshbite.com
              </a>
              .
            </p>
          </div>
        </div>

        <FooterPage />
      </div>
    );
  }
}
export default TermsPage;
